import { strings } from "../i18n/strings.es-AR.js";
import { voteCsat } from "../hooks/useConversation.js";
import { Icon } from "./icons.jsx";

const OPTIONS = [
  { score: 1, icon: "frown", label: strings.csatBad },
  { score: 3, icon: "meh", label: strings.csatNeutral },
  { score: 5, icon: "smile", label: strings.csatGood }
];

// Encuesta CSAT inline: tres botones grandes; al votar queda congelada
// mostrando la elección (la respuesta viaja como texto "1"/"3"/"5", que es
// lo que parsea el csatDispatcher).
export function CsatInline({ message }) {
  if (!message?.csat) return null;

  if (message.csatVote != null) {
    const chosen = OPTIONS.find((o) => o.score === message.csatVote);
    return (
      <p class="mt-1 pl-1 text-xs text-white/70">
        {strings.csatThanks} {chosen ? `(${chosen.label})` : ""}
      </p>
    );
  }

  return (
    <div class="mt-2 flex gap-2 pl-1">
      {OPTIONS.map((o) => (
        <button
          key={o.score}
          type="button"
          class="flex flex-1 flex-col items-center gap-1 rounded-xl border border-slate-200 bg-white px-2 py-2.5 text-xs shadow-sm active:bg-slate-50 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100 dark:active:bg-slate-700"
          onClick={() => voteCsat(message.key, o.score)}
        >
          <Icon name={o.icon} size={20} class="text-flux-primary dark:text-flux-cyan" />
          {o.label}
        </button>
      ))}
    </div>
  );
}
